import { ArrowLeft, Compass, Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { sendCustomEvent } from '@Analytics';
import { FullPageStatus } from '@Components/FullPageStatus';

const NotFound = ({ customMessage }: { customMessage?: string }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const wrongURL = params['*'];

  const fullMessage = customMessage ? t(customMessage) : t('Global.PageNotFoundMessage');
  const [title, ...descriptionLines] = fullMessage.split('\n');
  const description = descriptionLines.join('\n');

  const goHome = () => {
    sendCustomEvent('BUTTON_CLICKED', { buttonName: 'GO_HOME', wrongURL });
    navigate('/');
  };

  const goBack = () => {
    sendCustomEvent('BUTTON_CLICKED', { buttonName: 'GO_BACK', wrongURL });
    navigate(-1);
  };

  return (
    <FullPageStatus
      watermark="404"
      tone="brand"
      icon={Compass}
      title={title}
      description={description}
      actions={[
        { label: t('Global.GoBack'), icon: ArrowLeft, variant: 'secondary', onClick: goBack },
        { label: t('Global.GoHome'), icon: Home, variant: 'primary', onClick: goHome },
      ]}
    />
  );
};

export default NotFound;
